import { render, staticRenderFns } from "./HeaderSection.vue?vue&type=template&id=12c046d5&scoped=true"
import script from "./HeaderSection.vue?vue&type=script&lang=ts"
export * from "./HeaderSection.vue?vue&type=script&lang=ts"
import style0 from "./HeaderSection.vue?vue&type=style&index=0&id=12c046d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c046d5",
  null
  
)

export default component.exports